import { template as template_1d1fb0ace8ed450d93033ee96db2fdb1 } from "@ember/template-compiler";
import BsInputControl from 'ember-bootstrap/components/bs-form/element/control/input';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import Component from '@glimmer/component';
export default class TextControl extends Component {
    get inputUnitsClass() {
        const length = this.args.units.length;
        // eslint-disable-next-line unicorn/explicit-length-check
        const size = this.args.size ? `-${this.args.size}` : '';
        return `input-units-${length}ch${size}`;
    }
    static{
        template_1d1fb0ace8ed450d93033ee96db2fdb1(`
    <div class="position-relative d-flex align-items-center {{if @units this.inputUnitsClass}}">
      <BsInputControl
        @type={{@type}}
        @id={{@id}}
        @disabled={{@disabled}}
        @readonly={{@readonly}}
        @ariaDescribedBy={{@ariaDescribedBy}}
        @value={{@value}}
        @size={{@size}}
        @validationType={{@validationType}}
        @onChange={{@onChange}}
        ...attributes
      />
      {{#if @readonly}}
        <div class="position-absolute end-0 top-0 d-flex align-items-center p-3 h-100">
          <FaIcon @icon="lock" @prefix="fas" @size='sm' class="text-gray-400 input-icon"/>
        </div>
      {{/if}}
      {{#if @units}}
        <label class="text-gray-500 position-absolute end-0 {{if @disabled "opacity-50"}}">
          {{@units}}
        </label>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
